import axios from '../AxiosWrapper'
import {
  USER_LOAD_FAIL,
  USER_LOAD_REQUEST,
  USER_LOAD_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT_REQUEST,
  USER_LOGOUT_SUCCESS
} from '../constants/user.constants'

// Load User
export const loadUser = () => async (dispatch) => {
  dispatch({
    type: USER_LOAD_REQUEST
  })

  // The session rides on an httpOnly cookie, which axios sends because of
  // `withCredentials`. There is no token in localStorage to put in a header —
  // nothing in this portal ever writes one.
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }

  try {
    const res = await axios.get(
        `${process.env.REACT_APP_API_HOST}auth/refresh`,
        {},
        config
    )
    dispatch({
      type: USER_LOAD_SUCCESS,
      payload: res.data
    })
  } catch (error) {
    dispatch({
      type: USER_LOAD_FAIL
    })
  }
}

// Login User
export const login = ({ email, password }) => async (dispatch) => {
  dispatch({
    type: USER_LOGIN_REQUEST
  })

  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }

  try {
    const res = await axios.post(
        `${process.env.REACT_APP_API_HOST}auth/login`,
        { email, password },
        config
    )

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: res.data
    })
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL
    })
  }
}

// Logout
export const logout = () => async (dispatch) => {
  dispatch({
    type: USER_LOGOUT_REQUEST
  })

  try {
    // The same half of the API the login came from. `auth/login` sets the
    // session cookie with no `domain`; `api/v1/logout` cleared it with
    // `domain=.12wbt.com`. Those are different cookies as far as the browser
    // is concerned, so it kept the one it had — the screen logged out and the
    // session behind it did not.
    await axios.get(`${process.env.REACT_APP_API_HOST}auth/logout`)

    dispatch({
      type: USER_LOGOUT_SUCCESS
    })
  } catch (error) {
    // Signed out on this side regardless. A logout that cannot reach the
    // server must not leave an admin looking signed in.
    dispatch({
      type: USER_LOGOUT_SUCCESS
    })
  }
}
